import { useCallback } from 'react';

import PopoutIcon from '@/features/Icons/PopoutIcon';

import { prepareDetachedNavigation } from '@/logic/detached-session';
import { isDetachedMode, isEmbeddedInLobby } from '@/logic/embedded-mode';
import { notifyShellDetachRequested } from '@/logic/web-wrapper/web-wrapper-shell';

export const LaunchDetachedButton = () => {
  const handleLaunchDetached = useCallback(async () => {
    const { transferId } = prepareDetachedNavigation({
      targetUrl: window.location.href,
    });

    if (!transferId) {
      return;
    }

    await notifyShellDetachRequested({
      transferId,
      launcherUrl: window.location.href,
      popupAlreadyOpened: false,
    });
  }, []);

  if (!isEmbeddedInLobby() || isDetachedMode()) {
    return null;
  }

  return (
    <button
      type="button"
      className="launch-detached-button"
      aria-label="Open game in new window"
      data-testid="launch-detached-button"
      onClick={() => void handleLaunchDetached()}
    >
      <PopoutIcon />
    </button>
  );
};
